/**
 * Lead form budget / timeline options. `value` is the canonical code sent in
 * makeContact meta (`priceRange` / `purchaseTimeframe`) and must match CRM/Mautic mappings.
 * `uiKey` is stable for selection/highlighting in the widget.
 */
export type LeadOption = {
  labelKey: string
  value: string
  uiKey: string
}

export const LEAD_BUDGET_OPTIONS: LeadOption[] = [
  {
    labelKey: 'contactForm.budget250_350',
    value: '250-350',
    uiKey: 'budget_250_350',
  },
  {
    labelKey: 'contactForm.budget350_500',
    value: '350-500',
    uiKey: 'budget_350_500',
  },
  {
    labelKey: 'contactForm.budget500_750',
    value: '500-750',
    uiKey: 'budget_500_750',
  },
  {
    labelKey: 'contactForm.budget750_1000',
    value: '750-1000',
    uiKey: 'budget_750_1000',
  },
  {
    labelKey: 'contactForm.budget1000_plus',
    value: '1000+',
    uiKey: 'budget_1000_plus',
  },
]

export const LEAD_TIMELINE_OPTIONS: LeadOption[] = [
  {
    labelKey: 'contactForm.timelineAsap',
    value: 'asap',
    uiKey: 'timeline_asap',
  },
  {
    labelKey: 'contactForm.timeline0_3',
    value: '0-3',
    uiKey: 'timeline_0_3',
  },
  {
    labelKey: 'contactForm.timeline3_6',
    value: '3-6',
    uiKey: 'timeline_3_6',
  },
  {
    labelKey: 'contactForm.timeline6_12',
    value: '6-12',
    uiKey: 'timeline_6_12',
  },
]

/** @deprecated Use LEAD_BUDGET_OPTIONS */
export const MAUTIC_PRICE_RANGE_OPTIONS = LEAD_BUDGET_OPTIONS
/** @deprecated Use LEAD_TIMELINE_OPTIONS */
export const MAUTIC_PURCHASE_TIMEFRAME_OPTIONS = LEAD_TIMELINE_OPTIONS
